// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__vN6tX","content":"FallbackPage_content__bXFqb"};